import React from 'react';
import PropTypes from 'prop-types';
import InputText from '../../Common/InputText';
import Toggle from '../../Common/Toggle/Toggle';
import Button from '../../Common/Button';
import Select from 'react-select';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import Notification from '../../Common/Notification';
import * as types from '../../../constants/actionTypes';
import Drawer from '../../Common/Drawer/Drawer';
import { DATE_FORMAT } from '../../../constants/constants';
import Moment from 'moment';

export default class BaselinesForm extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            baseline: {
                id: 0,
                name: '',
                description: '',
                isActive: true,
                jobTitles: [],
                users: []
            },
            selectedNewJobTitle: null, // selected in dropdown
            selectedExistingJobTitleIds: null, // selected in list
            selectedNewUser: null,
            selectedExistingUserIds: null,
            isLoading: false,
            isFormValid: true,
            jobTitles: [],
            users: [],
            usersInModeratorRole: []
        };
    }

    componentDidMount = async () => {
        if (this.props.baselineId && this.props.baselineId > 0) {
            await this.getBaseline();
        }
        
        await this.loadFilters();
    }

    loadFilters = async () => {
        try {
            this.setState({ isLoading: true });
            const result = await this.props.baselineActions.loadFilters({ subscriptionId: this.props.subscriptionId });
            const payload = result.payload;
            if (result.type === types.LOAD_BASELINE_FILTERS_SUCCESS) {
                this.setState({ jobTitles: payload.jobTitles, users: payload.users, usersInModeratorRole: payload.usersInModeratorRole });
                // when creating a new baseline all jobtitles and users are selected by default
                if(this.state.baseline.id === 0){
                    const nonModeratorUsers = payload.users.filter(option =>
                        !payload.usersInModeratorRole.some(item => item.id === option.id)
                    );

                    const newBaseline = { 
                        ...this.state.baseline,
                        jobTitles: payload.jobTitles,
                        users: nonModeratorUsers
                    };

                    this.setState({ baseline: newBaseline });
                }
            } else if (result.type === types.LOAD_BASELINE_FILTERS_FAILURE) {
                Notification("error", "An Error Occurred", payload.message)
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    getBaseline = async () => {
        try {
            this.setState({ isLoading: true });
            const result = await this.props.baselineActions.getBaseline(this.props.baselineId);
            if (result.type === types.GET_BASELINE_SUCCESS) {
                
                this.setState({ baseline: result.payload, isLoading: false });
                
            } else if (result.type === types.GET_BASELINE_FAILURE) {
                Notification("error", "An Error Occurred", result.payload.message)
                this.props.cancelClick();
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
            this.props.cancelClick();
        }
    }

    onTextChange = (e) => {
        this.onFormChange(e.target.name, e.target.value);
    }

    onToggleChange = (name, value) => {
        this.onFormChange(name, value);
    }

    addNewJobTitle = () => {
        const newJobTitle = this.state.selectedNewJobTitle;

        if (newJobTitle) {
            let ar = this.state.jobTitles.slice();
            const obj = ar.find(x => x.id === newJobTitle.id);

            if (obj) {
                let selectedJobTitles = this.state.baseline.jobTitles;
                selectedJobTitles.push(obj);
                ar.splice(ar.indexOf(obj), 1);
                this.setState({ 
                    jobTitles: ar,
                    baseline: { ...this.state.baseline, jobTitles: selectedJobTitles },
                    selectedNewJobTitle: null
                });
            }
            
        }
    }

    removeSelectedExistingJobTitle = () => {
        const ids = this.state.selectedExistingJobTitleIds;

        if (ids) {
            let ar = this.state.baseline.jobTitles.slice();
            let jobTitles = this.state.jobTitles.slice();

            ids.forEach(id => {
                const obj = ar.find(x => x.id === parseInt(id));
                
                if (obj) {
                    jobTitles.push(obj);
                    ar.splice(ar.indexOf(obj), 1);
                }
            });

            this.setState({ 
                jobTitles: jobTitles,
                baseline: { ...this.state.baseline, jobTitles: ar } });
        }
    }

    selectNewJobTitle = (e) => {
        this.setState({ selectedNewJobTitle: e });
    }

    selectExistingJobTitle = (obj) => {
        let ids = [];
        const options = obj.currentTarget.options;
        for(let i = 0; i < options.length; i++) {
            if(options[i].selected) {
                ids.push(options[i].value);
            }
        }
        this.setState({ selectedExistingJobTitleIds: ids });
    }

    renderJobTitleList = () => {
        let options = [];
        this.state.baseline.jobTitles.forEach(function (option) {
            options.push(
                <option key={option.id} value={option.id}>{option.name}</option>
            );
        });
        return options;
    }

    removeSelectedExistingUser = () => {
        let ids = this.state.selectedExistingUserIds;

        if (ids) {
            let ar = this.state.baseline.users.slice();
            let users = this.state.users.slice();
            ids.forEach(id => {
                const obj = ar.find(x => x.id === parseInt(id));

                if (obj) {
                    users.push(obj);
                    ar.splice(ar.indexOf(obj), 1);
                }
            });
            this.setState({ 
                users: users,
                baseline: { ...this.state.baseline, users: ar } 
            });
        }
    }

    selectNewUser = (e) => {
        this.setState({ selectedNewUser: e });
    }

    selectExistingUser = (obj) => {
        let ids = [];
        const options = obj.currentTarget.options;
        for(let i = 0; i < options.length; i++) {
            if(options[i].selected) {
                ids.push(options[i].value);
            }
        }
        this.setState({ selectedExistingUserIds: ids });
    }

    addNewUser = () => {
        const user = this.state.selectedNewUser;

        if (user) {
            let ar = this.state.users.slice();
            const obj = ar.find(x => x.id === user.id);

            if (obj) {
                let selectedUsers = this.state.baseline.users;

                if (!selectedUsers.some(u => u.id === obj.id)) {
                    selectedUsers.push(obj);
                    ar.splice(ar.indexOf(obj), 1);
                    this.setState({ 
                        users: ar,
                        baseline: { ...this.state.baseline, users: selectedUsers },
                        selectedNewUser: null
                    });
                } 
            }
        }
    }

    onFormChange = (name, value) => {
        this.setState({ baseline: { ...this.state.baseline, [name]: value } });
    }

    isFormValid = () => {
        const { name, users, jobTitles } = this.state.baseline;

        if (name.length === 0)
        {
            return false;
        }

        if (users.length === 0)
        {
            Notification("error", "At least one user is required", "");
            return false;
        }

        if (jobTitles.length === 0)
        {
            Notification("error", "At least one job title is required", "");
            return false;
        }

        return true;
    }

    renderCurrentUserList = () => {
        let options = [];
        let addedKeys = [];

        this.state.baseline.users.forEach(function (option) {
            if (!addedKeys.includes(option.id)) {
                options.push(
                    <option key={option.id} value={option.id}>{option.name}</option>
                );

                addedKeys.push(option.id);
            } else {
                Notification("error", "Error", "User already added")
            }
        });

        return options;
    }

    saveClick = async () => {
        if (this.isFormValid()) {
            await this.save();
        } else {
            this.setState({ isFormValid: false });
        }
    }

    async save() {
        try {
            this.setState({ isLoading: true });
            const nb = {
                id: this.state.baseline.id,
                name: this.state.baseline.name,
                description: this.state.baseline.description,
                isActive: this.state.baseline.isActive,
                subscriptionId: this.state.baseline.subscriptionId,
                jobTitleIds: [],
                userIds: [],
                projectKey: this.props.projectKey ? this.props.projectKey : null
            };

            // only send in the Ids of the user and jobTitles
            for (var i = 0; i < this.state.baseline.jobTitles.length; i++) {
                nb.jobTitleIds.push(this.state.baseline.jobTitles[i].id);
            }

            for (var j = 0; j < this.state.baseline.users.length; j++) {
                nb.userIds.push(this.state.baseline.users[j].id);
            }

            const result = await this.props.baselineActions.saveBaseline(nb);

            if (result.type === types.CREATE_BASELINE_SUCCESS || result.type === types.UPDATE_BASELINE_SUCCESS) {
                Notification("success", "Save Successful", "Baseline saved successfully")
                this.props.saveClick();
            } else if (result.type === types.UPDATE_BASELINE_FAILURE || result.type === types.CREATE_BASELINE_FAILURE) {
                Notification("error", "An Error Occurred", result.payload.message)
                this.setState({ isLoading: false });
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
            this.setState({ isLoading: false });
        }

    }

    render() {
        return (
            <Drawer isWide={false} title="Baseline" onSaveClick={this.saveClick} onCancelClick={this.props.cancelClick}>
                <LoadingIndicator isLoading={this.state.isLoading} hideWhileLoading={true} isFullscreen={true}>
                    <div className="identifier-form">
                        <form noValidate className={this.state.isFormValid ? "" : "was-validated"}>
                            <InputText name="name" label="Name" placeholder="Name" type="text" value={this.state.baseline.name} onChange={this.onTextChange} isRequired={true} errorMessage="Name is required" />
                            <InputText name="description" label="Description" placeholder="Description" type="text" value={this.state.baseline.description} onChange={this.onTextChange} isRequired={false} />
                            <Toggle name="isActive" text="Active" checked={this.state.baseline.isActive} onChange={this.onToggleChange} />
                            <input type="submit" className="d-none" />
                        </form>

                        <div className="d-flex justify-content-between align-items-center">
                            <div className="flex-grow-1 me-2">
                                <Select
                                    name="baseline-job-titles"
                                    options={this.state.jobTitles}
                                    getOptionLabel={opt => opt.name}
                                    getOptionValue={opt => opt.id}
                                    onChange={this.selectNewJobTitle}
                                    value={this.state.selectedNewJobTitle}
                                    style={{ width: "270px" }}
                                    placeholder="Search for Job Title to Add..."
                                    disabled={this.state.baseline.jobTitles && this.state.jobTitles.length == this.state.baseline.jobTitles.length}
                                />
                            </div>
                            <div>
                                <button className="btn ms-2" onClick={this.addNewJobTitle}><i className="fas fa-plus-circle fa-lg"></i></button>
                            </div>
                        </div>
                        <span className="has-float-label">
                            <select id="baselineJobTitles" className="form-control mt-3" multiple size="8" onChange={this.selectExistingJobTitle}>
                                {this.state.baseline.jobTitles && this.renderJobTitleList()}
                            </select>
                            <label htmlFor="baselineJobTitles">Current Job Titles</label>
                        </span>

                        <div className="text-end">
                            <Button type="button" bootstrapClass="btn btn-outline-secondary mt-2" name="btnRemoveJobTitle" text="Remove Selected" onClick={this.removeSelectedExistingJobTitle} />
                        </div>

                        <br />

                        <div className="d-flex justify-content-between align-items-center">
                            <div className="flex-grow-1 me-2">
                                <Select
                                    name="baseline-users"
                                    options={this.state.users}
                                    getOptionLabel={opt => opt.name}
                                    getOptionValue={opt => opt.id}
                                    onChange={this.selectNewUser}
                                    value={this.state.selectedNewUser}
                                    className="w-100" 
                                    placeholder="Search for User to Add..."
                                    isDisabled={this.state.baseline.users && this.state.users.length === this.state.baseline.users.length}
                                />
                            </div>
                            <button className="btn" onClick={this.addNewUser}>
                                <i className="fas fa-plus-circle fa-lg"></i>
                            </button>
                        </div>

                        <span className="has-float-label">
                            <select id="baselineUserList" className="form-control mt-3" multiple size="8" onClick={this.selectExistingUser}>
                                {this.state.baseline.users && this.renderCurrentUserList()}
                            </select>
                            <label htmlFor="baselineUserList">Current Users</label>
                        </span>
                        <div className="text-end">
                            <Button type="button" bootstrapClass="btn btn-outline-secondary mt-2 mb-2" name="btnRemoveUser" text="Remove Selected" onClick={this.removeSelectedExistingUser} />
                        </div>
                        <div>
                            Last Location Task Date: {this.state.baseline.latestTaskDate ? Moment.utc(this.state.baseline.latestTaskDate).format(DATE_FORMAT) : "none"}
                        </div>
                    </div>
                </LoadingIndicator>
            </Drawer>
        );
    }

}

BaselinesForm.propTypes = {
    subscriptionId: PropTypes.string.isRequired,
    cancelClick: PropTypes.func.isRequired,
    saveClick: PropTypes.func.isRequired,
    baselineActions: PropTypes.object.isRequired,
    baselineId: PropTypes.number,
    projectKey: PropTypes.string
}
